/**
 * Enum and display labels for calling-summary case statuses.
 */

export enum CallingStatus {
  RESOLVED = "Resolved",
  UNRESOLVED = "Unresolved",
  CALL_NOT_NEEDED = "Call Not Needed",
}

export const CallingStatusLabels: Record<CallingStatus, string> = {
  [CallingStatus.RESOLVED]: "Resolved",
  [CallingStatus.UNRESOLVED]: "Unresolved",
  [CallingStatus.CALL_NOT_NEEDED]: "Call Not Needed",
};

export const CALLING_STATUS_COLORS: Record<
  CallingStatus,
  { color: string; backgroundColor: string }
> = {
  [CallingStatus.RESOLVED]: {
    color: "#003d15",
    backgroundColor: "#eefcf4",
  },
  [CallingStatus.UNRESOLVED]: {
    color: "#cc0300",
    backgroundColor: "#ffe8e8",
  },
  [CallingStatus.CALL_NOT_NEEDED]: {
    color: "#c24400",
    backgroundColor: "#fff3e0",
  },
};
